import { createContext } from 'react';
export const UserContext = createContext();
export const AuthContext = createContext();
export const CodeContext = createContext();
